module.exports = __webpack_public_path__ + "img/bezagu.75d56969.png";